import logo from "../../assets/tenants/il_parrocchiale/logo_il_parrocchiale.png";
import { TenantConfig } from "../types";
import { IlParrocchialeAboutUsPage } from "./pages/AboutUsPage";
import { IlParrocchialePrivacyPolicyPage } from "./pages/PrivacyPolicyPage";
import { IlParrocchialeTermsAndConditionsPage } from "./pages/TermsAndConditionsPage";

export const ilParrocchialeTenant: TenantConfig = {
  id: "il_parrocchiale",
  companyName: "Il Parrocchiale",
  companyDisplayName: "Il Parrocchiale",
  appName: "il_parrocchiale",
  logo,
  logoAlt: "Logo Il Parrocchiale",
  contactEmail: "Contatto organizzatori da definire",
  contactAddress: "Parrocchia San Luigi, Reggio Emilia",
  registrationLink: "https://docs.google.com/forms/d/e/1FAIpQLSf2DogtoIaQSzGz1MmKAdp690dEGdD4zbiC53aIIPu5n5zepA/viewform?usp=publish-editor",
  enableCalendar: true,
  theme: {
    navbarBg: "#ffd60a",
    navbarHoverBg: "#facc15",
    navbarActiveBg: "#eab308",
    navbarText: "#111827",
    navbarHoverText: "#111827",
    navbarActiveText: "#111827",
  },
  pages: {
    AboutUsPage: IlParrocchialeAboutUsPage,
    PrivacyPolicyPage: IlParrocchialePrivacyPolicyPage,
    TermsAndConditionsPage: IlParrocchialeTermsAndConditionsPage,
  },
};
